import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useFetchOptions from "./hooks/use-fetch-options.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { vehicleOptions } = useFetchOptions();

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data/hora inicial *"
                        selected={filters.dtStart ? new Date(filters.dtStart) : null}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data/hora final *"
                        selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <SelectComponent
                        label='Veículo'
                        isMulti={false}
                        wrapValues={true}
                        options={vehicleOptions}
                        value={filters.vehicle}
                        onChange={(value) => setFilters(prev => ({...prev, vehicle: value}))}
                        instanceId="vehicle"
                        classNameWrapper={"w-full"}
                    />

                    <div className={"ml-1"}>
                        <InputCheckbox
                            id="showImages"
                            label="Exibir imagens"
                            checked={filters.showImages}
                            onChange={(e) => setFilters(prev => ({...prev, showImages: e.target.checked}))}
                        />
                    </div>

                </form>
            </div>
        </>
    );
};

export default Filters;